export default "__VITE_ASSET__a14ef30f__"